
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { AppModule } from '@/store/module'
  import Swiper, { Pagination, Autoplay }  from 'swiper'
  import 'swiper/swiper-bundle.css';

  interface Banner {
    imgUrl: string;
    name: string;
    title?: string;
    desc?: string;
    color?: string;
    link?: string;
  }

  Swiper.use([Pagination, Autoplay])

  @Component
  export default class BannerSlides extends Vue {
    bannerIndex = 0

    @Prop(Array)
    banners: Banner[]

    get isH5() {
      return AppModule.isH5
    }

    mounted() {
      const banners = this.banners
      const router = this.$router
      this.$nextTick(() => {
        const bannersSwiper = new Swiper('.banner-slides', {
          slidesPerView: 1,
          loop: true,
          /*
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          */
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            click(swiper, e) {
              const target = e.target as HTMLElement;
              const className = target.className
              // 按钮事件不响应
              if (className && className.indexOf('btn') === -1) {
                const index = this.realIndex
                if (!banners[index].link) {
                  return
                }
                router.push({
                  name: banners[index].link
                })
              }
            }
          }
        })
        bannersSwiper.on('slideChange', this.changeBannerIndex)
      })
    }

    changeBannerIndex(swiper: Swiper) {
      this.bannerIndex = swiper.activeIndex
    }

    bannerClick (banner) {
      if (!banner.link) return
      this.$router.push({
        name: banner.link
      })
    }
  }
